module.exports = __webpack_public_path__ + "img/thumb-paint.7febd794.png";